<div tabindex="1">
  <div aria-labelledby="ngl_modal_header_1" aria-hidden="false" role="dialog" class="slds-modal slds-fade-in-open">
    <div class="slds-modal__container">
      <!-- Header -->
      <div class="slds-modal__header">
        <button type="button" nglbuttonicon="inverse" class="slds-modal__close slds-button slds-button--icon-inverse" (click)="close()">
          <i class="material-icons" style="font-size: 22px; top: -2px; left: -2px; margin: 0; cursor: pointer">&#xE5CD;</i>
        </button>

        <h2 id="ngl_modal_header_1" class="slds-text-heading--medium">Reset password</h2>

        <button class="btn" (click)="resetPassword()">Reset</button>
      </div>

      <div class="slds-modal__content slds-p-around--medium" style="padding: 0 0 12px 0">
        <div class="list-group list-group-modal">
          <div class="list-group-item-container">
            <div class="list-group-item">
              <div class="row-picture">
                <!--<img class="circle" src="css/images/avatar.png" alt="ZZ">-->
                <div class="avatar-icon" [ngClass]="getStyle(currentUser?.userName)">{{currentUser?.userLogin | trigrammePipe}}</div>
              </div>
              <div class="row-content">
                <span class="list-group-item-heading">{{currentUser?.userFirstName}} {{currentUser?.userName}}</span>

                <div class="list-group-item-text">
                  <div class="container-fluid">
                    <div class="row">
                      <div class="col-md-12">{{currentUser?.userMailAddress}}<i class="material-icons">&#xE0BE;</i></div>
                      @if (currentUser?.userPhoneNumber) {
                        <div class="col-md-12">{{currentUser?.userPhoneNumber}}<i class="material-icons">&#xE0CD;</i></div>
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group label-floating" style="margin: 34px 10px 0 10px;">
          <label for="userPassword" class="control-label">New password</label>
          <input id="userPassword" name="userPassword" type="text" [(ngModel)]="newPassword" class="form-control input-modal" />
        </div>
      </div>
    </div>
  </div>

  <div class="slds-backdrop slds-backdrop--open"></div>
</div>
